// node_modules
import { 
    createContext, 
    Dispatch, 
    useReducer 
} from "react";
// Reducers
import { CaseReducer } from "Reducers";
// Interfaces
import { ICaseAction } from "Interfaces";
// Types
import { TCaseState } from "Types";
// Constants
import { CasePhaseConstants } from "Constants";

// Initial main state of the app at the start
const initialCaseState: TCaseState = {
    casePhase: CasePhaseConstants.PHASE_2.toLowerCase(),
    isDeliveryRedesign: false,
    isDynamicDelivery: false,
    conceptTechnologyList: { concepts: [], additionalTechnologies: [], publishedPhaseOptions: {
        doShowRadar: false,
        doShowRequirementsTable: false
    }},
    selectedEntityId: -1,
    selectedEntityName: "Overview",
    selectedEntityNumbering: ""
};

// Context is created using React’s createContext() hook. 
// Passing a default state and dispatch function here isn't necessary 
// since it is set after by the provider.
// But we do it anyway for better code auto-completion in the IDE.
export const CaseContext = createContext<{
    caseState: TCaseState;
    caseDispatch: Dispatch<ICaseAction>;
}>({
    caseState: initialCaseState,
    caseDispatch: () => null
});

export const CaseStore = ({ children }: any) => {
    // When using hook,
    // we get access to 2 values:
    // - a current state,
    // - and a dispatch function.
    // useReducer takes 2 parameters:
    // - the state reducer,
    // - and an initial state
    const [caseState, caseDispatch] = useReducer(CaseReducer, initialCaseState);

    return (
        <CaseContext.Provider value={ { caseState, caseDispatch } }>
            { children }
        </CaseContext.Provider>
    );
};
